;(function ($) {

	$(document).ready(function(){

        $('.testimonial-slider-photos').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            prevArrow: jQuery('#box-slick-previous'),
            nextArrow: jQuery('#box-slick-next'),
            asNavFor: '.testimonial-slider-quotes'
        });
        $('.testimonial-slider-quotes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.testimonial-slider-photos',
            dots: false,
            centerMode: false,
            focusOnSelect: false
        });

        $('.all-gallery-images').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            centerMode: false,
			arrows: false,
            focusOnSelect: false
        });



		$('.services-image-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
			dots: false,
			centerMode: true,
			centerPadding: '150px',
            asNavFor: '.services-caption-slider',
			responsive: [
			    {
			      breakpoint: 1023,
			      settings: {
					centerMode: false
			      }
			    }
			]
        });
        $('.services-caption-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.services-image-slider',
            dots: false,
			arrows: true,
			prevArrow: jQuery('#box-slider-slick-previous'),
			nextArrow: jQuery('#box-slider-slick-next'),
			fade: true
        });


	});





})(jQuery);
